import React, { Component } from 'react';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "./settings.css";
import ResourceStatus from 'LIBRARY/Components/ResourceStatus/ResourceStatus';
import CallIndexSeries from 'LIBRARY/Components/Settings/CallIndexSeries/CallIndexSeries';
import GrantAccess from 'LIBRARY/Components/Settings/GrantAccess/GrantAccess';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RulesPolicies from './RulesPolicies/RulesPolicies';
import ReceiptDesign from './ReceiptDesign/ReceiptDesign';
import LinkedInstitutes from './LinkedInstitutes/LinkedInstitutes';
import DepartmentWiseRestriction from './DepartmentWiseRestriction/DepartmentWiseRestriction';
import deptWiseResponsibleIcon from "LIBRARY/CommonResources/images/departmentWiseResponsible.svg";
import DueDateNotification from './DueDateNotification/DueDateNotification';
import RulesAndConfiguration from './RulesAndConfiguration/RulesAndConfigration';

class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showSettingsTab: true,
            resourceStatus: false,
            callIndexSeries: false,
            rulesPolicies: false,
            receiptDesign: false,
            linkedInstitute: false,
            departmentWiseResponsible: false,
            dueDateNotification: false,
            rulesAndConfiguration: false,
        };
    }


    // TO OPEN LIBRARY SETTINGS
    openLibrarySettings = (type) => {

        if (type == 'resourceStatus') {
            this.setState({
                showSettingsTab: false,
                resourceStatus: true,
            });
        }
        if (type == 'callIndexSeries') {
            this.setState({
                showSettingsTab: false,
                callIndexSeries: true
            });
        }
        if (type == 'grantAccess') {
            this.setState({
                showSettingsTab: false,
                grantAccess: true
            });
        }
        if (type == 'rulesPolicies') {
            this.setState({
                showSettingsTab: false,
                rulesPolicies: true
            });
        }
        if (type == 'receiptDesign') {
            this.setState({
                showSettingsTab: false,
                receiptDesign: true
            });
        }
        if (type == 'linkedInstitute') {
            this.setState({
                showSettingsTab: false,
                linkedInstitute: true
            });
        }
        if (type == 'departmentWiseResponsible') {
            this.setState({
                showSettingsTab: false,
                departmentWiseResponsible: true
            });
        }
        if (type == 'dueDateNotification') {
            this.setState({
                showSettingsTab: false,
                dueDateNotification: true
            });
        }
        if (type == 'rulesAndConfiguration') {
            this.setState({
                showSettingsTab: false,
                rulesAndConfiguration: true
            });
        }
    }

    // METHOD TO CLOSE ADMISSION TYPE
    closeResourceStatus = () => {
        this.setState({
            showSettingsTab: true,
            resourceStatus: false

        });
    }

    closeCallIndexSeries = () => {
        this.setState({
            showSettingsTab: true,
            callIndexSeries: false
        });
    }

    closeGrantAccess = () => {
        this.setState({
            showSettingsTab: true,
            grantAccess: false
        });
    }

    closeRulesPolicies = () => {
        this.setState({
            showSettingsTab: true,
            rulesPolicies: false
        });
    }

    closeReceiptDesign = () => {
        this.setState({
            showSettingsTab: true,
            receiptDesign: false
        });
    }

    closeLinkedInstitute = () => {
        this.setState({
            showSettingsTab: true,
            linkedInstitute: false
        });
    }

    closeDepartmentWiseResponsible = () => {
        this.setState({
            showSettingsTab: true,
            departmentWiseResponsible: false
        });
    }

    closeDueDateNotification = () => {
        this.setState({
            showSettingsTab: true,
            dueDateNotification: false
        });
    }

    closeRulesAndConfiguration = () => {
        this.setState({
            showSettingsTab: true,
            rulesAndConfiguration: false
        });
    }

    render() {
        return (
            <>
                <RoutingMenu activeScreen="settings" />


                {this.state.showSettingsTab && (
                    <div className="libraryComponents-container">
                        <div>
                            <div className="pl-3">
                                <h4>Setting</h4>
                            </div>
                            <div className="settingData col-md-12">
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view resource status' onClick={() => this.openLibrarySettings('resourceStatus')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <FontAwesomeIcon className="mb-2" icon={["fa", "file-alt"]} />
                                            Resource Status
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view call index series' onClick={() => this.openLibrarySettings('callIndexSeries')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <FontAwesomeIcon className="mb-2" icon={["fa", "list"]} />
                                            Call Index Series
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view grant access' onClick={() => this.openLibrarySettings('grantAccess')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <FontAwesomeIcon className="mb-2" icon={["fa", "user-lock"]} />
                                            Grant Access
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view receipt design' onClick={() => this.openLibrarySettings('receiptDesign')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <FontAwesomeIcon className="mb-2" icon={["fa", "receipt"]} />
                                            Receipt Design
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view rules and policies' onClick={() => this.openLibrarySettings('rulesPolicies')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <FontAwesomeIcon className="mb-2" icon={["fa", "gavel"]} />
                                            Rules and Policies
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view linked institute' onClick={() => this.openLibrarySettings('linkedInstitute')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <FontAwesomeIcon className="mb-2" icon={["fa", "link"]} />
                                            Linked Institute
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view department wise restriction' onClick={() => this.openLibrarySettings('departmentWiseResponsible')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <img src={deptWiseResponsibleIcon} alt='deptWiseResponsible' style={{ cursor: 'pointer', height: '16px', width: '16px' }} />
                                            Department-Wise Responsible
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view Resource Due Date Notification' onClick={() => this.openLibrarySettings('dueDateNotification')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                             <FontAwesomeIcon className="mb-2" icon={["fa", "sync-alt"]} />
                                            Resource Due Date Notification
                                        </div>
                                    </div>
                                </div>
                                <div className="card resourceStatusCard settingCard card-responsive" title='Click to view Rules and Configuration' onClick={() => this.openLibrarySettings('rulesAndConfiguration')} >
                                    <div className="card-body ">
                                        <div className="settingTitle">
                                            <FontAwesomeIcon className="mb-2" icon={["fa", "sync"]} />
                                            Rules and Configration
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.resourceStatus && (
                    <ResourceStatus
                        closeResourceStatus={this.closeResourceStatus}
                    />
                )}
                {this.state.callIndexSeries && (
                    <CallIndexSeries
                        closeCallIndexSeries={this.closeCallIndexSeries}
                    />
                )}
                {this.state.grantAccess && (
                    <GrantAccess
                        closeGrantAccess={this.closeGrantAccess}
                    />
                )}
                {this.state.rulesPolicies && (
                    <RulesPolicies
                        closeRulesPolicies={this.closeRulesPolicies}
                    />
                )}
                {this.state.receiptDesign && (
                    <ReceiptDesign
                        closeReceiptDesign={this.closeReceiptDesign}
                    />
                )}
                {this.state.linkedInstitute && (
                    <LinkedInstitutes
                        closeLinkedInstitute={this.closeLinkedInstitute}
                    />
                )}
                {this.state.departmentWiseResponsible && (
                    <DepartmentWiseRestriction
                        closeDepartmentWiseResponsible={this.closeDepartmentWiseResponsible}
                    />
                )}
                {this.state.dueDateNotification && (
                    <DueDateNotification
                        closeDueDateNotification={this.closeDueDateNotification}
                    />
                )}
                {this.state.rulesAndConfiguration && (
                    <RulesAndConfiguration
                        closeRulesAndConfiguration={this.closeRulesAndConfiguration}
                    />
                )}
            </>
        );
    }
}

export default Settings;